"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What a surface shows when a read it needed did not answer: the server's
* message, and a way to ask again.
*
* Shared because the reason the retry is *not* the boundary's own `retry` is
* shared. Clearing a caught failure remounts the child, which asks for the
* same query under the same key, and the store answers with the failure it
* already holds — so the error paints again at once. Asking again means
* changing the key, which is what `useReloadKey` does, and the surface hands
* that function here.
*
* The appearance stays the surface's: the line is styled by whoever draws it,
* because an error on a reader's screen and an error in a curator's console
* are not the same sentence in the same red. What is shared is the structure
* and the semantics, which is all that was ever duplicated.
*/
function ReadFailure(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(props.textStyle)), {}, {
      role: "alert",
      children: props.message
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: props.onAskAgain,
      type: "button",
      children: "Try again"
    })]
  });
}
var _default = exports.default = ReadFailure;